import React from "react";
import PropTypes from "prop-types";

export const ServiceLink = (props) => (
  <span>
    <a href={`/services/edit?id=${props.service.moduleGroupId}`}>
      {props.service.name}
    </a>
  </span>
);

export default ServiceLink;

ServiceLink.propTypes = {
  service: PropTypes.object,
};
